import { get } from 'lodash';
import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface ContractState {
  newCardFees: Record<string, any>;
  deliveryFees: Record<string, any>;
  lunchCommission: number;
  recreationalCommission: number;
  transportCommission: number;
  feesVatPercentage: number;
  isLoading: boolean;
  loaded: boolean;
  isError?: boolean;
  noPersistance: boolean;
}

export const getInitialState = (): ContractState => ({
  newCardFees: {},
  deliveryFees: {},
  lunchCommission: 0,
  recreationalCommission: 0,
  transportCommission: 0,
  feesVatPercentage: 0,
  isLoading: false,
  loaded: false,
  noPersistance: true
});

interface ActionPayload {
  payload?: {
    newCardFees?: Record<string, any>;
    deliveryFees?: Record<string, any>;
    lunchCommission?: number;
    recreationalCommission?: number;
    transportCommission?: number;
    feesVatPercentage?: number;
  };
}

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_CARD_FEES}_REQUEST`]: (): Partial<ContractState> => ({
    isLoading: true
  }),

  [`${ApiConstants.LOAD_CARD_FEES}_SUCCESS`]: (
    state: ContractState,
    { payload }: ActionPayload
  ): Partial<ContractState> => ({
    newCardFees: get(payload, 'newCardFees') || {},
    deliveryFees: get(payload, 'deliveryFees') || {},
    lunchCommission: get(payload, 'lunchCommission') || 0,
    recreationalCommission: get(payload, 'recreationalCommission') || 0,
    transportCommission: get(payload, 'transportCommission') || 0,
    feesVatPercentage: get(payload, 'feesVatPercentage') || 0,
    loaded: true,
    isLoading: false
  }),

  [`${ApiConstants.LOAD_CARD_FEES}_FAILURE`]: (
    state: ContractState
  ): Partial<ContractState> =>
    !state.isError
      ? {
          isLoading: false,
          loaded: true,
          isError: true
        }
      : state
});
